import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CoreModule } from '@fs/core';
import { ApiModule } from './api/api.module';
@NgModule({
  declarations: [],
  imports: [
    CoreModule,
    ApiModule
  ]
})
export class PfevCoreModule { }
